import React from 'react';

const individuals = [
  {
    name: 'Dr Martin Crous',
    url: 'https://www.martincrous.com',
    desc: 'Executive Catalyst – Sparking growth through personal business and executive development'
  },
  {
    name: 'Dr Leon Steyn',
    url: 'https://leonsteyn.net/homepage',
    desc: 'Executive Leadership Coach and Trainer'
  },
  {
    name: 'Johan Bester',
    url: 'https://www.motivemoves.co.za',
    desc: 'Relationships / Belonging / Character – A certified People Code Master Trainer where I incubate belonging and togetherness in leaders, teams, families and individuals, and help them reach relationship actualisation'
  } 
];

export default function Individuals() {
  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <h2 style={{ color: '#333', borderBottom: '2px solid #ccbc74', paddingBottom: 10, marginBottom: 20 }}>Individual Partners</h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {individuals.map((person) => (
          <li key={person.name} style={{ marginBottom: 24, padding: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0, color: '#444' }}>{person.name}</h3>
            <p style={{ color: '#666', fontStyle: 'italic', marginBottom: 12 }}>{person.desc}</p>
            <a 
              href={person.url} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                color: '#ccbc74', 
                textDecoration: 'none', 
                fontWeight: 500,
                display: 'inline-block',
                borderBottom: '1px solid transparent',
                transition: 'border-color 0.3s'
              }}
              onMouseOver={(e) => e.target.style.borderBottomColor = '#ccbc74'}
              onMouseOut={(e) => e.target.style.borderBottomColor = 'transparent'}
            >
              Visit Website
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
} 